import { Component, OnInit, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { CheckStepperService } from '../services/check-stepper';
import { PendingCheckPermissionService } from '../services/pending-check-permission';
import { ChecklistSelfcheck } from '../selfcheck/checklist-selfcheck/checklist-selfcheck';
import { CommentComponent } from '../../../shared/ui/comment-component/comment-component';
import { SortCommentsDescPipe } from '../../../shared/pipes/sort-comments-desc.pipe';
import { CheckHeaderBar } from './ui/check-header-bar/check-header-bar';
import { CheckInfoCard } from './ui/check-info-card/check-info-card';
import { DocumentCommentsCard } from './ui/document-comments-card/document-comments-card';

import { PendingCheckFacadeStore } from './store/pending-check-facade.store';
import {JsonPipe} from '@angular/common';

@Component({
  selector: 'app-pending-checks',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatIcon,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ChecklistSelfcheck,
    CommentComponent,
    SortCommentsDescPipe,
    CheckHeaderBar,
    CheckInfoCard,
    DocumentCommentsCard,
    JsonPipe,
  ],
  templateUrl: './pending-checks.html',
  styleUrl: './pending-checks.scss',
})
export class PendingChecks implements OnInit {
  readonly facade = inject(PendingCheckFacadeStore);
  readonly permission = inject(PendingCheckPermissionService);
  private readonly stepperService = inject(CheckStepperService);
  private readonly route = inject(ActivatedRoute);

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const checkId = params.get('id');
      const projectCode = params.get('projectCode');

      this.facade.initializeCheck(checkId, projectCode);
    });
  }


  selfCheckDone(): boolean {
    return this.stepperService.selfCheckDone();
  }

  checkerIsConsultant(): boolean {
    return this.stepperService.checkerIsConsultant();
  }

  checkerIsCreator(): boolean {
    return this.permission.checkerIsCreator();
  }


  addComment(text: string) {
    if (text && text.trim()) {
      this.facade.addGeneralComment(text.trim(), 'WARNING');
    }
  }

  onSaveComment(docId: string, text: string) {
    this.facade.addDocumentComment(docId, text, 'WARNING');
  }

  onCommentDoneToggled(event: { guid: string; isDone: boolean }) {
    this.facade.updateCommentStatus(event.guid, event.isDone);
  }

  onCommentSeverityToggled(event: { guid: string; severity: string }) {
    this.facade.setCommentSeverity(event.guid, event.severity);
  }

  onCommentDeleted(guid: string) {
    this.facade.deleteComment(guid);
  }
}
